import { useEffect } from "react";
import { createPortal } from "react-dom";
import { siteTexts } from "../i18n/siteTexts";
import "./Toast.css";

type ToastVariant = "success" | "error";

type ToastProps = {
  message: string;
  variant?: ToastVariant;
  durationMs?: number;
  onClose: () => void;
};

export default function Toast({
  message,
  variant = "success",
  durationMs = 3500,
  onClose,
}: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const timeout = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(timeout);
  }, [message, durationMs, onClose]);

  const content = (
    <div className={`app-toast app-toast--${variant}`} role="status" aria-live="polite">
      <span>{message}</span>
      <button
        type="button"
        className="app-toast-close"
        onClick={onClose}
        aria-label={siteTexts.common.close}
      >
        ×
      </button>
    </div>
  );

  if (typeof document === "undefined") return content;
  return createPortal(content, document.body);
}
